import { render, staticRenderFns } from "./EditTecnico.vue?vue&type=template&id=44cc2fea"
import script from "./EditTecnico.vue?vue&type=script&lang=js"
export * from "./EditTecnico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports